class PolyalphabeticAlgorithm {
  constructor(setParams) {
    this.setParams = setParams;
  }

  getInputs(params) {
    return <div>No inputs required for Polyalphabetic</div>;
  }
}

export default PolyalphabeticAlgorithm;